(function($) {

    $.fn.sortableheader = function() {

        return this.each(function() {
            var $this = $(this);

            $this.click(function(e){
                if ($(e.target).closest(':input,label,a').size()==0) {
                    $(this).find("a")[0].click();
                }
            });
        });
    };

})(jQuery);